/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionStatus } from './CompetitionStatus';
import {
    CompetitionStatusFromJSON,
    CompetitionStatusFromJSONTyped,
    CompetitionStatusToJSON,
    CompetitionStatusToJSONTyped,
} from './CompetitionStatus';
import type { CreateCompetitionBodyItemsInner } from './CreateCompetitionBodyItemsInner';
import {
    CreateCompetitionBodyItemsInnerFromJSON,
    CreateCompetitionBodyItemsInnerFromJSONTyped,
    CreateCompetitionBodyItemsInnerToJSON,
    CreateCompetitionBodyItemsInnerToJSONTyped,
} from './CreateCompetitionBodyItemsInner';
import type { UpdateCompetitionBodyOnboardingSection } from './UpdateCompetitionBodyOnboardingSection';
import {
    UpdateCompetitionBodyOnboardingSectionFromJSON,
    UpdateCompetitionBodyOnboardingSectionFromJSONTyped,
    UpdateCompetitionBodyOnboardingSectionToJSON,
    UpdateCompetitionBodyOnboardingSectionToJSONTyped,
} from './UpdateCompetitionBodyOnboardingSection';
import type { CreateCompetitionBodyRecurrence } from './CreateCompetitionBodyRecurrence';
import {
    CreateCompetitionBodyRecurrenceFromJSON,
    CreateCompetitionBodyRecurrenceFromJSONTyped,
    CreateCompetitionBodyRecurrenceToJSON,
    CreateCompetitionBodyRecurrenceToJSONTyped,
} from './CreateCompetitionBodyRecurrence';
import type { CreateCompetitionBodyFaqsInner } from './CreateCompetitionBodyFaqsInner';
import {
    CreateCompetitionBodyFaqsInnerFromJSON,
    CreateCompetitionBodyFaqsInnerFromJSONTyped,
    CreateCompetitionBodyFaqsInnerToJSON,
    CreateCompetitionBodyFaqsInnerToJSONTyped,
} from './CreateCompetitionBodyFaqsInner';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface UpdateCompetitionBody
 */
export interface UpdateCompetitionBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    description?: string;
    /**
     * 
     * @type {Array<CreateCompetitionBodyItemsInner>}
     * @memberof UpdateCompetitionBody
     */
    items?: Array<CreateCompetitionBodyItemsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompetitionBody
     */
    isRecurring?: boolean;
    /**
     * 
     * @type {CreateCompetitionBodyRecurrence}
     * @memberof UpdateCompetitionBody
     */
    recurrence?: CreateCompetitionBodyRecurrence;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    eventName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    banner?: string;
    /**
     * 
     * @type {UpdateCompetitionBodyOnboardingSection}
     * @memberof UpdateCompetitionBody
     */
    onboardingSection?: UpdateCompetitionBodyOnboardingSection;
    /**
     * 
     * @type {Array<CreateCompetitionBodyFaqsInner>}
     * @memberof UpdateCompetitionBody
     */
    faqs?: Array<CreateCompetitionBodyFaqsInner>;
    /**
     * 
     * @type {CompetitionStatus}
     * @memberof UpdateCompetitionBody
     */
    status?: CompetitionStatus;
    /**
     * How the competition is displayed — "embedded" (inline platform) or "microsite" (standalone slug URL)
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    displayMode?: string;
    /**
     * URL slug used when displayMode is "microsite" (e.g. "apex-legends-invitational")
     * @type {string}
     * @memberof UpdateCompetitionBody
     */
    micrositeSlug?: string;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof UpdateCompetitionBody
     */
    prerequisites?: Array<Prerequisite>;
}



/**
 * Check if a given object implements the UpdateCompetitionBody interface.
 */
export function instanceOfUpdateCompetitionBody(value: object): value is UpdateCompetitionBody {
    return true;
}

export function UpdateCompetitionBodyFromJSON(json: any): UpdateCompetitionBody {
    return UpdateCompetitionBodyFromJSONTyped(json, false);
}

export function UpdateCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CreateCompetitionBodyItemsInnerFromJSON)),
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurrence': json['recurrence'] == null ? undefined : CreateCompetitionBodyRecurrenceFromJSON(json['recurrence']),
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : UpdateCompetitionBodyOnboardingSectionFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CreateCompetitionBodyFaqsInnerFromJSON)),
        'status': json['status'] == null ? undefined : CompetitionStatusFromJSON(json['status']),
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'micrositeSlug': json['micrositeSlug'] == null ? undefined : json['micrositeSlug'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
    };
}

export function UpdateCompetitionBodyToJSON(json: any): UpdateCompetitionBody {
    return UpdateCompetitionBodyToJSONTyped(json, false);
}

export function UpdateCompetitionBodyToJSONTyped(value?: UpdateCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CreateCompetitionBodyItemsInnerToJSON)),
        'isRecurring': value['isRecurring'],
        'recurrence': CreateCompetitionBodyRecurrenceToJSON(value['recurrence']),
        'eventName': value['eventName'],
        'sponsorId': value['sponsorId'],
        'ruleSetId': value['ruleSetId'],
        'hero': value['hero'],
        'banner': value['banner'],
        'onboardingSection': UpdateCompetitionBodyOnboardingSectionToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CreateCompetitionBodyFaqsInnerToJSON)),
        'status': CompetitionStatusToJSON(value['status']),
        'displayMode': value['displayMode'],
        'micrositeSlug': value['micrositeSlug'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
    };
}

